import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import {Link, StyledPageCenterContainer, pxToEm} from '../../components/globalStyles';
import HexagonIconImage from '../../components/hexagonIconImage';
import Layout from '../../components/layout/layout';
import PageViewHeadline from '../../components/pageViewHeadline';
import BitmovinPlayer from '../../components/player/bitmovinPlayer';
import WhoIsUsingSection from '../../components/whoIsUsingSection';
import {CompanyName} from '../../data/customerData';
import {Product, ProductToHexagonIconSrc} from '../../data/product';
import {AppRoutePathFunction} from '../../logic/routes';
import {RootState} from '../../logic/store';
import {State as SalesDemosState} from '../../logic/store/salesDemosStore';
import RtmpPath from '../../media/partnerIcons/rtmp.png';
import SrtPath from '../../media/partnerIcons/srt.png';
import ZixiSvgPath from '../../media/partnerIcons/zixi.svg';
import NoteworthyFeaturesSection from '../liveEncodingPageView/noteworthyFeaturesSection';

import CloudLiveEncodingAccordions from './liveEncodingAccordions';

//#region Styled Components
const StyledContent = styled.div`
  padding-top: ${pxToEm(89)}em;
  padding-bottom: ${pxToEm(114)}em;
`;

const StyledContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 50%;
`;

const StyledTwoColumnsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;

  > ${StyledContentColumn} {
    flex: 1 1 50%;

    :nth-child(1) {
      padding-right: 5%;
    }

    :nth-child(2) {
      border-left: 2px solid ${baseVariables.colors.darkBlueGray};
      padding-left: 5%;
    }
  }
`;

const StyledH2 = styled.h2`
  font-size: ${pxToEm(24)}em;
  color: ${baseVariables.colors.midnight};
  display: inline-block;
  margin-top: ${pxToEm(55) / pxToEm(24)}em;
`;

const StyledP = styled.p`
  font-size: ${pxToEm(20)}em;
  line-height: 1.6;
  margin: 0;
  margin-bottom: ${pxToEm(55) / pxToEm(24)}em;
`;

const StyledBitmovinPlayer = styled(BitmovinPlayer)``;
const StyledPlayerHelper = styled.div`
  width: 100%;
`;

const StyledSpan = styled.span`
  margin-left: ${pxToEm(8)}em;
`;

const StyledPartnerImage = styled.img`
  width: 33%;
`;

const StyledLink = styled(Link)`
  color: rgb(31, 169, 224);
  :hover {
    text-decoration: underline;
  }
`;

const StyledAccordions = styled(CloudLiveEncodingAccordions)`
  margin-top: ${pxToEm(70)}em;
`;

//#endregion

interface MapStateToProps {
  salesDemos?: SalesDemosState;
}

interface Props extends MapStateToProps {}

class LiveEncodingPageView extends React.Component<Props> {
  public render() {
    const baseUrl = this.props.salesDemos.response.baseUrl;
    const dashUrl = `${baseUrl}live-to-vod/createLiveManifest.php`;

    const source = {
      title: 'Live Demo',
      dash: dashUrl
    };

    const config = {
      playback: {
        autoplay: true,
        muted: true
      }
    };
    return (
      <Layout>
        <PageViewHeadline
          topSubHeadline={'Live Encoding'}
          headline={'A new standard of quality'}
          badgeComponent={<HexagonIconImage iconSrc={ProductToHexagonIconSrc[Product.LiveEncoding]} />}
        />

        <StyledPageCenterContainer>
          <StyledContent>
            <StyledP>
              We are not just building another live encoder in the cloud, but a software solution that is resilient and
              cost-efficient. High quality is non-negotiable when generating live streams. Let’s check out our latest
              demos around a live streaming experience.
            </StyledP>

            <StyledTwoColumnsSection>
              <StyledContentColumn>
                <NoteworthyFeaturesSection />
              </StyledContentColumn>
              <StyledContentColumn>
                <StyledPlayerHelper>
                  <StyledBitmovinPlayer source={source} config={config} />
                </StyledPlayerHelper>

                <StyledH2>Partners</StyledH2>
                <StyledP>
                  <StyledLink to={AppRoutePathFunction.DemoDetail({demoId: 'b5953808-980a-11e9-b128-42010a840215'})}>
                    Live streaming with SRT:
                  </StyledLink>
                  <StyledSpan>
                    Combine Bitmovin’s benefits with SRT and enable high-quality streaming for live events
                  </StyledSpan>
                </StyledP>
                <StyledP>
                  <StyledLink to={AppRoutePathFunction.DemoDetail({demoId: 'b5953722-980a-11e9-b128-42010a840215'})}>
                    Live streaming with Zixi:
                  </StyledLink>
                  <StyledSpan>
                    You can implement live contributions from Zixi-enabled network devices to Bitmovin’s cloud encoding
                    service.
                  </StyledSpan>
                </StyledP>
                <p>
                  <StyledPartnerImage src={ZixiSvgPath} alt="Zixi" />
                  <StyledPartnerImage src={SrtPath} alt="SRT" />
                  <StyledPartnerImage src={RtmpPath} alt="RTMP" />
                </p>
                <StyledAccordions />
              </StyledContentColumn>
            </StyledTwoColumnsSection>
          </StyledContent>
        </StyledPageCenterContainer>
      </Layout>
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  salesDemos: state.salesDemos
});

export default connect(mapStateToProps)(LiveEncodingPageView);
